module.exports = __webpack_public_path__ + "img/doorLogo36.709a5e9a.png";